import { render } from "./tinyWheel.vue?vue&type=template&id=7e6ebe75&scoped=true"
import script from "./tinyWheel.vue?vue&type=script&lang=js"
export * from "./tinyWheel.vue?vue&type=script&lang=js"

import "./tinyWheel.vue?vue&type=style&index=0&id=7e6ebe75&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6ebe75"]])

export default __exports__